import { useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { AuthMachine } from '@nhost/hasura-auth-js';
import { AuthContext } from '../components/provider';

/** @internal */
export const useAuthInterpreter = (): ActorRefFrom<AuthMachine> => {
  const auth = useContext(AuthContext);
  const interpreter = auth?.client.interpreter;
  if (!interpreter) throw Error('Could not find the Nhost auth client. Did you wrap your app in <NhostProvider />?');
  return interpreter;
};
